import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AllowedSupplierResponseModel } from '../models/allowed-supplier-response-model';
import { AllowedSupplierService } from '../allowed-supplier.service';

@Component({
    selector: 'edit-allowed-supplier',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [AllowedSupplierService],
    templateUrl: './edit-allowed-supplier.component.html'
})
export class EditAllowedSupplierComponent implements OnInit {
    @Input() supplier: AllowedSupplierResponseModel;
    @Input() isNew: boolean = false;

    public model: AllowedSupplierResponseModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private allowedSupplierService: AllowedSupplierService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                supplierId: '',
                supplierName: '',
                defaultCurrencyCode: '',
                isActive: true,
                businessContactEmail: '',
                technicalContactEmail: '',
                serviceNowGroup: ''
            };
        } else {
            this.model = { ...this.supplier };
        }
    }

    public save() {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.allowedSupplierService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the supplier. Please try again.';
                }
            });
        } else {
            this.allowedSupplierService.update(this.supplier.supplierId, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the supplier. Please try again.';
                }
            });
        }
    }

    public cancel() {
        this.activeModal.dismiss('cancel');
    }
}
